import { authRoutes } from './auth'
import { clientRoutes } from './clients'
import { dashboardRoutes } from './dashboard'
import { payrollsConfigRoutes } from './payrolls-config'
import { userRoutes } from './users'
import { employeesRoutes } from './employees'
import { companiesRoutes } from './companies'
import { approverRoutes } from './approvers'
import { documentRoutes } from './documents'
import { calendarRoutes } from './calendars'
import { certificationRoutes } from './certifications'
import { employeesConfigRoutes } from './employees-config'
import { reportRoutes } from './reports'
import { LettersRoutes } from './letters'
import NotFound from '@/shared/components/NotFound.vue'
import { calendarPeriodsRoutes } from './calendarPeriods'
import { RRHHRoutes } from './hr'

export const featureRoutes = [
  {
    path: '/',
    redirect: '/login',
  },
  //add 404 page
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
  ...dashboardRoutes,
  ...clientRoutes,
  ...companiesRoutes,
  ...RRHHRoutes,
  ...payrollsConfigRoutes,
  ...authRoutes,
  ...userRoutes,
  ...employeesRoutes,
  ...approverRoutes,
  ...calendarRoutes,
  ...documentRoutes,
  ...certificationRoutes,
  ...employeesConfigRoutes,
  ...reportRoutes,
  ...LettersRoutes,
  ...calendarPeriodsRoutes,
]
